<template>
  <router-view/>
</template>

<style lang="scss">
@import 'assets/css/style.scss';
@import 'assets/css/default.scss';
</style>
